import React, { useEffect, useState } from "react";
import axios from "../../AxiosInstance";
import { Table } from "antd";
import Header3 from "../../components/Header3";
import Footer2 from "../../components/Footer2";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import toast from "react-hot-toast";
import Sidebar from "../../components/Sidebar";

const AllDataUser = () => {
  const [users, setUsers] = useState([]); // ✅ Default empty array
  const [activities, setActivities] = useState();

  useEffect(() => {
    fetchAllUsers();
  }, []);

  const fetchAllUsers = async () => {
    try {
      const storedAuth = JSON.parse(localStorage.getItem("auth"));
      const token = storedAuth?.token;

      if (!token) {
        console.error("❌ Token missing in localStorage");
        return;
      }

      const res = await axios.get("api/v1/auth/getAllUsers", {
        headers: { Authorization: `Bearer ${token}` },
      });

      console.log("✅ API Response:", res.data); // Debugging ke liye

      if (res.data && res.data.success) {
        // ✅ Ensure every user has a 'key' for AntD Table
        const usersWithKeys = res.data.data.map((user, index) => ({
          ...user,
          key: user._id || index, // AntD requires a unique key
        }));

        // Sort by createdAt (newest first) - descending order
        const sorted = usersWithKeys.sort((a, b) => {
          const dateA = new Date(a.createdAt || a._id);
          const dateB = new Date(b.createdAt || b._id);
          return dateB - dateA; // Descending order (newest first)
        });

        console.log("✅ Users With Keys:", sorted); // Debugging
        setUsers(sorted);
      }
    } catch (error) {
      console.error(
        "❌ Error fetching users:",
        error.response?.data?.message || error.message
      );
    }
  };

  const handleDownloadExcel = () => {
    if (!users || users.length === 0) {
      console.error("❌ No user data available");
      return;
    }

    // ✅ Convert users array to worksheet
    const worksheet = XLSX.utils.json_to_sheet(users);

    // ✅ Create a new workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Users");

    // ✅ Convert workbook to binary data
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    // ✅ Create a Blob and save as Excel file
    const excelFile = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(excelFile, "Users_List.xlsx");
  };

  // const blockUser = async (userId) => {
  //   try {
  //     const response = await axios.delete(`/api/v1/admin/block-user/${userId}`);
  //     toast.success(response.data.message); // Show success message
  //     window.location.reload(); // Refresh the table after deletion
  //   } catch (error) {
  //     console.error(
  //       "Error blocking user:",
  //       error.response?.data?.message || error.message
  //     );
  //     toast.error(error.response?.data?.message || error.message);
  //   }
  // };

  // antD table columns

  const blockUser = async (userId) => {
    try {
      const response = await axios.delete(`api/v1/admin/block-user/${userId}`);
      toast.success(response.data.message);

      // ✅ Remove user from UI without reloading
      setUsers((prevUsers) => prevUsers.filter((user) => user._id !== userId));
    } catch (error) {
      console.error(
        "Error blocking user:",
        error.response?.data?.message || error.message
      );
      toast.error(error.response?.data?.message || error.message);
    }
  };

  useEffect(() => {
    axios.get("api/v1/auth/activities").then((res) => {
      setActivities(res.data);
    });
  }, []);
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Ambassador",
      dataIndex: "isAmbassador",
      render: (text, record) => (
        <span>{record.isAmbassador ? "Yes" : "No"}</span>
      ),
    },
    {
      title: "Last Activity",
      key: "latestActivity",
      render: (text, record) => (
        <div>
          <div>{record.latestActivity}</div>
          <div style={{ fontSize: "11px", color: "gray" }}>
            {record.activityTime
              ? new Date(record.activityTime).toLocaleString()
              : ""}
          </div>
        </div>
      ),
    },

    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (text, record) => (
        <div className="d-flex">
          <button
            className="btn btn-danger"
            onClick={() => blockUser(record._id)}
          >
            Block
          </button>
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="d-md-flex gap-2  ">
        <Sidebar />
        <div className="containerr prrrt pb-5 w-full px-2">
          <h1 className="text-center mt-4">Users </h1>
          <div className=".ant-table-container ">
            {users.length > 0 ? (
              <>
                <Table
                  columns={columns}
                  dataSource={users}
                  pagination={{ pageSize: 6 }}
                  scroll={{ x: "500px" }} // 👈 Yeh line add karni hai
                />
                <div className="d-flex justify-content-end">
                  <button
                    className="text-white    subbtnmeet border-0 fs-18 fw600 rounded-1"
                    style={{
                      width: "135px",
                      height: "44px",
                      backgroundColor: "#62C0C7",
                    }}
                    onClick={handleDownloadExcel}
                    disabled={users.length === 0}
                  >
                    Download
                  </button>
                </div>
              </>
            ) : (
              <p className="text-center">Loading users...</p>
            )}
          </div>
        </div>
      </div>

      {/* <Footer2 /> */}
    </>
  );
};

export default AllDataUser;
